﻿import Valg from '../../../Shared/Scripts/Models/Valg';

export interface ValgState {
    lanebelop?: Valg<string>;
    rente?: Valg<string>;
    nedbetalingstidAar?: number;
    nedbetalingstidMaaneder?: number;
    visHeleKalkulator: boolean;
}

export const UPDATE_VALG = 'UPDATE_VALG';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export type ValgStateActionTypes = UpdateValgAction;
